<template>
    <div>
      <nuxt/>
    </div>
</template>

<script>
    export default {
        name: "h5PageLayout"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// layouts/h5PageLayout.vue